<template>
	<div class="dlogD">
		<transition name="fade" mode="out-in" :duration="500">
			<div class="loginD" v-if="pageType==1" key="a">
				<div class="dlogD_tit">欢迎 登录 1522智能设计中心</div>
				<div class="dlog_body">
					<div class="unameApasD">
						<div class="unameInp">
							<input v-model="login_uname" type="" placeholder="手机号或者用户名" name="" id="" value="" />
						</div>
						<div class="unameInp">
							<input v-model="login_pas" type="password" placeholder="输入密码" name="" id="" value="" />
						</div>
						<p class="forgetPas" @click="switchLoginAregister(3)">忘记密码？<span>找回</span></p>
						<div class="loginBtn" @click="login_api">登 录</div>
						<p class="noUsername">还没有账号？<span @click="switchLoginAregister(2)">去注册 ></span></p>
					</div>
				</div>
			</div>

			<div class="loginD" v-if="pageType==2" key="b">
				<div class="dlogD_tit">欢迎 注册 1522智能设计中心</div>
				<div class="dlog_body">
					<input type="text" name="" id="" value="" class="in_hid" />
					<input type="password" name="" id="" value="" class="in_hid" />
					<div class="unameApasD">
						<div class="unameInp">
							<input v-model="res_uname" type="" placeholder="输入用户名" name="" id="" value="" />
						</div>
						<div class="unameInp" style="position: relative;">
							<input v-model="res_phone" type="" placeholder="输入手机号码" name="" id="" value="" />
							<div class="getPhoneCodeBtn" :class="res_code_text == '获取验证码'?'':'sendCla'" @click="getRes_code_api">{{res_code_text}}</div>
						</div>
						<div class="unameInp">
							<input v-model="res_code" type="text" placeholder="验证码" name="" id="" value="" />
						</div>
						<div class="unameInp">
							<input v-model="res_pas_1" type="password" placeholder="输入密码" name="" id="" value="" />
						</div>
						<div class="unameInp">
							<input v-model="res_pas_2" type="password" placeholder="确认密码" name="" id="" value="" />
						</div>
						<div class="loginBtn" @click="rigster_api">注 册</div>
						<p class="noUsername">已有账号？<span @click="switchLoginAregister(1)">去登录 ></span></p>
					</div>
				</div>
			</div>

			<div class="loginD" v-if="pageType==3" key="c">
				<div class="dlogD_tit">找回密码</div>
				<div class="dlog_body">
					<input type="text" name="" id="" value="" class="in_hid" />
					<input type="password" name="" id="" value="" class="in_hid" />
					<div class="unameApasD">
						<div class="unameInp" style="position: relative;">
							<input v-model="zh_accout" type="" placeholder="输入账号" name="" id="" value="" />
							<div class="getPhoneCodeBtn" :class="jianA_code_text == '开始找回'?'':'sendCla'" @click="yzAccount">{{jianA_code_text}}</div>
						</div>
						<div class="isS" v-if="zh_A_account">
							<p style="width:80%;margin: auto;padding-left: 20px;font-size: 12px;margin-bottom: 10px;">已向手机号码<span style="font-size: 14px;"> 182****9979</span>发送了一条验证码</p>
							<div class="unameInp">
								<input v-model="zh_code" type="text" placeholder="验证码" name="" id="" value="" />
							</div>
							<div class="unameInp">
								<input v-model="zh_password" type="password" placeholder="输入新密码" name="" id="" value="" />
							</div>
							<div class="unameInp">
								<input v-model="zh_re_password" type="password" placeholder="确认新密码" name="" id="" value="" />
							</div>
							<div class="loginBtn" @click="resetPas">确 认 找 回 密 码</div>
							
						</div>
						<p class="noUsername">记起了密码？<span @click="switchLoginAregister(1)">去登录 ></span></p>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import "../../assets/js/swiper.min.js"
	export default {
		data() {
			return {
				pageType: 1,
				swiper_2: {},
				res_uname: '', //注册data参数
				res_phone: '',
				res_code: '',
				res_pas_1: '',
				res_pas_2: '',
				res_code_text: '获取验证码',
				ca: 'a', //vue translation切换
				login_uname: '',
				login_pas: '',
				jianA_code_text: '开始找回',
				zh_A_account: false, //验证账号是否成功
				zh_accout: '',
				zh_code: '',
				zh_phone: '',
				zh_phone_text:'',
				zh_password: '',
				zh_re_password: '',
			}
		},
		created: function() {

		},
		mounted: function() {
			let _this = this;

		},
		methods: {
			/**  * -----切换注册或者登录    
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			switchLoginAregister(index) {
				let _this = this;
				Object.assign(this.$data, this.$options.data());
				_this.pageType = index;
			},
			/**  * -----获取验证码    
			 * @version 1.0  * @author 您的大名 2019年11月28日  * */
			getRes_code_api() {
				let _this = this;
				let phone = _this.res_phone;
				_this.postApi('/api/sendCode', {
						phone: phone,
						auth_code: "ae8c8c8bc36b8aabc4516e06a915746e",
						type: 'reg'
					})
					.then((res) => {
						if(res.status == '00') {
							let time = 90;
							let time1 = setInterval(function() {
								time--;
								_this.res_code_text = '重新发送(' + time + 's)';
								if(time == 0) {
									_this.res_code_text = '获取验证码';
									clearInterval(time1);
								}
							}, 1000)
						} else {
							_this.$message.error(res.message)
						}
					})
					.catch((err) => {
						console.log(err)
					})
			},
			/**  * -----注册    
			 * @version 1.0  * @author 您的大名 2019年11月28日  * */
			rigster_api() {
				let _this = this;
				if(_this.res_uname == '') {
					_this.$message.error('请输入用户名');
					return;
				}
				if(_this.res_code == '') {
					_this.$message.error('请输入验证码');
					return;
				}
				if(_this.res_phone == '') {
					_this.$message.error('请输入手机号码');
					return;
				}
				if(_this.res_pas_1 != _this.res_pas_2) {
					_this.$message.error('密码不匹配');
					return;
				}
				let params = {
					account: _this.res_uname,
					code: _this.res_code,
					phone: _this.res_phone,
					password: _this.res_pas_1,
					re_password: _this.res_pas_2
				};
				_this.postApi('/api/memberReg', params)
					.then((res) => {
						console.log(res)
						if(res.status == '00') {
							_this.$message.success('注册成功');
							_this.pageType = 1;
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/**  * -----登录    
			 * @version 1.0  * @author 您的大名 2019年11月28日  * */
			login_api() {
				let _this = this;
				if(_this.login_uname == '') {
					_this.$message.error('请输入用户名');
					return;
				};
				if(_this.login_pas == '') {
					_this.$message.error('请输入密码');
					return;
				};
				let params = {
					account: _this.login_uname,
					password: _this.login_pas
				};
				_this.postApi('/api/checkMemberLogin', params)
					.then((res) => {
						//console.log(res)
						if(res.status == '00') {
							_this.$message.success('登录成功');
							localStorage.setItem("ind_access_token", res.data.access_token);
							localStorage.setItem("ind_user", JSON.stringify(res.data.info));
							//_this.$router.push('oUserAdmin_index');
							_this.$emit('parentMethod', 'login_success');
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/**  * -----找回密码验证账号    
			 * @version 1.0  * @author 您的大名 2019年11月28日  * */
			yzAccount() {
				let _this = this;
				_this.postApi('/api/accountCheck', {
						account: _this.zh_accout
					})
					.then((res) => {
						if(res.status == '00') {
							_this.jianA_code_text = '账号正确';
							_this.zh_phone = res.data.phone;
							_this.zh_getCode(_this.zh_phone);
						} else {
							_this.$message.error(res.message)
						}
					})
					.catch((err) => {
						console.log(err)
					})
			},
			/**  * -----找回密码获取验证码
			 * @version 1.0  * @author 您的大名 2019年11月28日  * */
			zh_getCode(phone){
				let _this = this;
				_this.postApi('/api/sendCode', {
						phone: phone,
						auth_code: "ae8c8c8bc36b8aabc4516e06a915746e",
						type: 'updatePas'
					})
					.then((res) => {
						if(res.status == '00') {
							_this.zh_A_account = true;
							_this.zh_phone_text = _this.zh_phone.substr(0,3)+"****"+_this.zh_phone.substr(7);
						} else {
							_this.$message.error(res.message)
						}
					})
					.catch((err) => {
						console.log(err)
					})
			},
			/**  * -----找回密码重置密码
			 * @version 1.0  * @author 您的大名 2019年11月28日  * */
			resetPas(){
				let _this = this;
				_this.postApi('/api/resetPas', {
						account: _this.zh_accout,
						phone: _this.zh_phone,
						code: _this.zh_code,
						password: _this.zh_password,
						re_password: _this.zh_re_password
					})
					.then((res) => {
						if(res.status == '00') {
							_this.$message.success('找回密码成功！');
							Object.assign(this.$data, this.$options.data());
							setTimeout(function(){
								_this.pageType = 1;
							},1500);
						} else {
							_this.$message.error(res.message)
						}
					})
					.catch((err) => {
						console.log(err)
					})
			},
		}
	}
</script>

<style scoped>
	.dlogD {}
	
	.loginD {
		background-color: #fff;
		border-radius: 10px;
		padding-top: 15px;
	}
	
	.dlogD_tit {
		text-align: center;
		font-size: 16px;
		height: 30px;
		line-height: 30px;
	}
	
	.dlog_body {
		padding: 30px 10px 20px 10px;
		margin: auto;
		background-color: rgba(255, 255, 255, 0);
	}
	
	.unameApasD {
		width: 80%;
		min-height: 10px;
		margin: auto;
	}
	
	.unameInp {
		text-align: center;
		display: block;
		margin: auto;
		margin-bottom: 20px;
		margin-top: 5px;
	}
	
	.unameInp input {
		line-height: 35px;
		width: 250px;
		border: 1px solid #ccc;
		padding-left: 10px;
		box-sizing: border-box;
	}
	
	.getPhoneCodeBtn {
		background-color: red;
		position: absolute;
		top: 0;
		right: 0;
		line-height: 39px;
		color: #fff;
		font-size: 12px;
		cursor: pointer;
		padding: 0 5px;
	}
	
	.getPhoneCodeBtn.sendCla {
		background-color: #ccc;
		opacity: 0.8;
	}
	
	.loginBtn {
		width: 250px;
		text-align: center;
		background-color: red;
		margin: auto;
		line-height: 35px;
		color: #fff;
		cursor: pointer;
	}
	
	.noUsername {
		width: 250px;
		text-align: right;
		padding: 0;
		margin: auto;
		margin-top: 15px;
	}
	
	.noUsername span {
		color: red;
		cursor: pointer;
	}
	
	.dlog_footer {
		text-align: right;
		padding: 10px 10px;
	}
	
	.dlog_footer button {
		margin-left: 20px;
	}
	
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .3s;
	}
	
	.fade-enter,
	.fade-leave-to
	/* .fade-leave-active below version 2.1.8 */
	
	{
		opacity: 0;
	}
	
	.forgetPas {
		text-align: right;
		width: 80%;
		margin: auto;
		padding: 0 30px 10px 10px;
		cursor: pointer;
		font-size: 12px;
	}
</style>